import { Show } from "solid-js";
import { isServer } from "solid-js/web";
import { parse } from "cookie-es";
import { getRequestEvent } from "solid-js/web";

const debug = false;

export default function LoggedInBar() {
  const event = getRequestEvent();
  const cookies = () =>
    parse(
      isServer ? (event!.request.headers.get("cookie") ?? "") : document.cookie,
    );

  const drupalSessionCookieNames = Object.keys(cookies()).filter(
    (k) =>
      k.startsWith("SESS") ||
      k.startsWith("SSESS") ||
      k.startsWith("DrupalSolidAuth"),
  );

  const isAuth = () => {
    return drupalSessionCookieNames.length > 0;
  };

  return (
    <Show when={isAuth() || debug}>
      <div
        class="logged-in-bar"
        style="padding: 90px 10px 1px ;background: orange; color: white;"
      >
        <p>
          Vous êtes connecté au back-office, les performances sont réduites.
          Vous pouvez vous déconnecter depuis <a href="/user/">cette page</a>.
        </p>
      </div>
    </Show>
  );
}
